module.exports = __webpack_public_path__ + "static/media/printableAzul.b0b9314b.png";